<section aria-labelledby="bannerHeadingSection">
  <div class="tab-banner-section">
    <figure>
      <img class="lg-hide" src="assets/img/supportmobile.jpg" alt="banner" />
      <img class="sm-hide" src="assets/img/supportimg1.jpg" alt="banner" />
    </figure>
    <div class="main-wrapper">
      <div class="tab-banner-caption">
        <div class="row">
          <div class="col-sm-12 col-md-8">
            <h1 id="bannerHeadingSection" class="heading"> Support</h1>
            <p class="">To get support for the device management program, you can: </p>
            <div class='tab-content-support'>
              <ul>
                <!-- <li> View frequently asked questions (FAQ). </li> -->
                <li> Call or chat with AT&T support representatives.</li>     
              </ul>
            </div>
          </div>
        </div>
        <div class="row1">
          <!-- <div class="col-sm-12 col-md-6"> -->
          <!--<p><strong>Learn more see <a class = "link" href="javascript:void(0)" (click)="openOverviewModal()">Overview Tutorial</a></strong></p>-->
          <!-- <button class="btn btn-secondary" href="javascript:void(0)" aria-label="Watch introductory video" title="Opens a Video about the Device Management Program" 
            (click)="openOverviewModal()">
              <img src="assets/img/playalt.svg" alt="" class="icon-play" /> Watch introductory video </button>
          </div> -->
        </div>
      </div>
      <div class="show-sm">
        <div class="col-sm-12">
          <h1> Support</h1>
          <p>To get support for the device management program, you can: </p>
          <div class='tab-content-support'>
            <ul>
              <!-- <li> View frequently asked questions (FAQ). </li> -->
              <li> Call or chat with AT&T support representatives.</li>
            </ul>
          </div>
        </div>
        <!-- <div class="col-sm-12">
          <button class="btn btn-secondary" href="javascript:void(0)" aria-label="Watch introductory video" title="Opens a Video about the Device Management Program"
           (click)="openOverviewModal()">
            <img src="assets/img/playalt.svg" alt="" class="icon-play" /> Watch introductory video
          </button>
        </div> -->
      </div>
    </div>
  </div>
</section>
<section aria-label="Support Links">
  <div class="container-box">
    <div class="row supportLink">
      <!-- <div class='faq-container'>
        <div class='contact-img-section'>
          <img class="faq-icon" src="assets/img/icon_faq.png" alt="Frequently asked questions" />
        </div>
        <div class='info-section'>
          <h2> Frequently asked questions </h2>
          <p class="limit"> View frequently asked questions about the device management program. </p>
          <button class="btn btn-secondary chat-btn hide-sm" routerLink="/faq"> View FAQ </button>
        </div>
        <div class="col-sm-12">
          <button class="btn btn-secondary chat-btn show-sm" routerLink="/faq"> View FAQ </button>
        </div>
      </div> -->
      <div class='contact-container'>
        <div class='contact-img-section'>
          <img class="contact-icon" src="assets/img/icon_contactus.png" alt="Contact us" />
        </div>
        <div class='info-section chat-section'>
          <h2> Contact us </h2>
          <p class="limit">Contact us by calling or chatting with a support representative. </p>
          <button class="btn btn-secondary chat-btn hide-sm" routerLink="/contact"> Contact us </button>
        </div>
        <div class="col-sm-12">
          <button class="btn btn-secondary chat-btn show-sm" routerLink="/contact"> Contact us </button>
        </div>
      </div>
    </div>
  </div>
</section>
<div *ngIf="showOverviewModal">
  <app-modal [showModal]="showOverviewModal" [modalClass]="modalClass">
    <app-gvp-video (modalOutput)="closeOverviewModal()" [triggerElement]='eventEmit' [videoId]="videoId">
    </app-gvp-video>
  </app-modal>
</div>
<br />